<template>
    <div class="add-assignee-config">
        <div class="config-field">
            <label>{{ $t("taskModuleRules.assignmentMethod") }}</label>
            <a-radio-group v-model="localConfig.method" @change="onMethodChange" button-style="solid">
                <a-radio-button value="static">{{ $t("taskModuleRules.static") }}</a-radio-button>
                <a-radio-button value="algorithmic">{{ $t("taskModuleRules.algorithmic") }}</a-radio-button>
                <a-radio-button value="random">{{ $t("taskModuleRules.random") }}</a-radio-button>
            </a-radio-group>
        </div>

        <!-- Static Method -->
        <div v-if="localConfig.method === 'static'" class="static-config">
            <div class="config-field">
                <label>{{ $t("taskModuleRules.users") }}</label>
                <a-select
                    v-model="localConfig.userList"
                    mode="multiple"
                    :placeholder="$t('taskModuleRules.selectUsers')"
                    style="width: 100%;"
                    @change="emitChange"
                >
                    <a-select-option
                        v-for="user in users"
                        :key="user._id"
                        :value="user._id"
                    >
                        {{ user.name }}
                    </a-select-option>
                </a-select>
            </div>
        </div>

        <!-- Algorithmic Method -->
        <div v-if="localConfig.method === 'algorithmic'" class="algorithmic-config">
            <div class="config-field">
                <label>{{ $t("taskModuleRules.userList") }}</label>
                <a-checkbox v-model="localConfig.useAllUsers" @change="onUseAllUsersChange">
                    {{ $t("taskModuleRules.allUsers") }}
                </a-checkbox>
            </div>

            <div v-if="!localConfig.useAllUsers" class="config-field">
                <a-select
                    v-model="localConfig.userList"
                    mode="multiple"
                    :placeholder="$t('taskModuleRules.selectUsers')"
                    style="width: 100%;"
                    @change="emitChange"
                >
                    <a-select-option
                        v-for="user in users"
                        :key="user._id"
                        :value="user._id"
                    >
                        {{ user.name }}
                    </a-select-option>
                </a-select>
            </div>

            <div class="config-field">
                <label>{{ $t("taskModuleRules.algorithm") }}</label>
                <a-select 
                    v-model="localConfig.algorithmSettings.algorithm" 
                    style="width: 100%;"
                    @change="emitChange"
                >
                    <a-select-option value="least_task">{{ $t("taskModuleRules.leastTask") }}</a-select-option>
                    <a-select-option value="round_robin">{{ $t("taskModuleRules.roundRobin") }}</a-select-option>
                </a-select>
            </div>

            <div class="config-field">
                <label>{{ $t("taskModuleRules.dateRange") }}</label>
                <a-select 
                    v-model="localConfig.algorithmSettings.dateRange" 
                    style="width: 100%;"
                    @change="emitChange"
                >
                    <a-select-option value="today">{{ $t("taskModuleRules.today") }}</a-select-option>
                    <a-select-option value="last_7_days">{{ $t("taskModuleRules.last7Days") }}</a-select-option>
                    <a-select-option value="last_30_days">{{ $t("taskModuleRules.last30Days") }}</a-select-option>
                </a-select>
            </div>

            <div class="config-field">
                <a-checkbox 
                    v-model="localConfig.algorithmSettings.checkOnlineStatus"
                    @change="emitChange"
                >
                    {{ $t("taskModuleRules.includeOnlyOnlineUsers") }}
                </a-checkbox>
            </div>
        </div>

        <!-- Random Method -->
        <div v-if="localConfig.method === 'random'" class="random-config">
            <div class="config-field">
                <label>{{ $t("taskModuleRules.userList") }}</label>
                <a-checkbox v-model="localConfig.useAllUsers" @change="onUseAllUsersChange">
                    {{ $t("taskModuleRules.allUsers") }}
                </a-checkbox>
            </div>

            <div v-if="!localConfig.useAllUsers" class="config-field">
                <a-select
                    v-model="localConfig.userList"
                    mode="multiple"
                    :placeholder="$t('taskModuleRules.selectUsers')"
                    style="width: 100%;"
                    @change="emitChange"
                >
                    <a-select-option
                        v-for="user in users"
                        :key="user._id"
                        :value="user._id"
                    >
                        {{ user.name }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "AddAssigneeConfig",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: {}
        };
    },
    computed: {
        ...mapState({
            users: state => state.user.users.data
        })
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal && JSON.stringify(newVal) !== JSON.stringify(this.localConfig)) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        onMethodChange() {
            if (this.localConfig.method === 'static') {
                this.localConfig.useAllUsers = false;
            }
            this.emitChange();
        },

        onUseAllUsersChange(checked) {
            if (checked) {
                this.localConfig.userList = [];
            }
            this.emitChange();
        }
    }
};
</script>

<style lang="scss" scoped>
.add-assignee-config {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }
    }
}
</style>
